import PageBackTitle from "../Component/PageBackTitle";
// import React, { useState, useEffect, useRef, useCallback } from "react";
// import { MdOutlineModeEditOutline } from "react-icons/md";
// import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";
// import { HiOutlinePlus } from "react-icons/hi";
// import { MdExpandMore } from "react-icons/md";
// import { TbRefresh } from "react-icons/tb";
// import Tooltip from "@mui/material/Tooltip";
// import { IoClose } from "react-icons/io5";
// import { IoEyeOutline } from "react-icons/io5";
// import axios from "axios";
// import API_URL from "../Config.js";
// import Pagination from "../Component/Pagination.js";
// import useClickOutside from "../useClickOutside";
// import "./expense.css";

// /* ─────────────────────────────────────────────────────────────────────
//    VIEW ADVANCE POPUP
// ───────────────────────────────────────────────────────────────────── */
// const ViewAdvancePopup = ({ advance, onClose }) => {
//   const fmtDate = (val) => {
//     if (!val) return "—";
//     try {
//       return new Date(val).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//     } catch {
//       return val;
//     }
//   };

//   const fmt = (val) =>
//     val != null
//       ? `₹${parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
//       : "—";

//   const rows = [
//     ["Advance given to", advance.employee_name],
//     ["Month", advance.advance_month],
//     ["Amount", fmt(advance.amount)],
//     ["Location", advance.location],
//     ["Notes", advance.notes],
//     ["Given By", advance.given_by_name],
//     ["Created", fmtDate(advance.created_at)],
//   ];

//   return (
//     <div className="exp-overlay">
//       <div className="exp-modal exp-modal--sm">
//         <div className="exp-modal__header">
//           <div className="exp-modal__title-wrap">
//             <div>
//               <h4 className="exp-modal__title">Advance Details</h4>
//               <p className="exp-modal__sub">
//                 {advance.employee_name} — {advance.advance_month}
//               </p>
//             </div>
//           </div>
//           <button className="exp-modal__close" onClick={onClose}>
//             <IoClose size={18} />
//           </button>
//         </div>

//         <div className="exp-modal__body">
//           <div className="exp-view-table">
//             {rows.map(([label, value]) => (
//               <div className="exp-view-row" key={label}>
//                 <span className="exp-view-row__label">{label}</span>
//                 <span className="exp-view-row__value">{value || "—"}</span>
//               </div>
//             ))}
//           </div>
//         </div>

//         {/* <div className="exp-modal__footer">
//           <button className="exp-btn exp-btn--ghost" onClick={onClose}>Close</button>
//         </div> */}
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────
//    ADD ADVANCE POPUP
// ───────────────────────────────────────────────────────────────────── */
// const AddAdvancePopup = ({ onClose, onSuccess, showSnackbar }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [users, setUsers] = useState([]);
//   const [usersLoading, setUsersLoading] = useState(true);
//   const [errors, setErrors] = useState({});
//   const [formData, setFormData] = useState({
//     user_id: "",
//     advance_month: new Date().toISOString().slice(0, 7),
//     amount: "",
//     location: "",
//     notes: "",
//   });

//   useEffect(() => {
//     (async () => {
//       try {
//         const authKey = localStorage.getItem("authKey");
//         const res = await axios.get(`${API_URL}/api/get_user`, {
//           headers: { Authorization: authKey },
//         });
//         const d = res.data;
//         setUsers(d.users || d.data || d || []);
//       } catch {
//         setUsers([]);
//       } finally {
//         setUsersLoading(false);
//       }
//     })();
//   }, []);

//   const handleChange = (field, value) => {
//     setFormData((p) => ({ ...p, [field]: value }));
//     if (errors[field]) setErrors((p) => ({ ...p, [field]: "" }));
//   };

//   const validate = () => {
//     const e = {};
//     if (!formData.user_id) e.user_id = "Advance given to is required";
//     if (!formData.advance_month) e.advance_month = "Month is required";
//     if (!formData.amount || isNaN(+formData.amount) || +formData.amount < 0)
//       e.amount = "Valid amount is required";
//     setErrors(e);
//     return !Object.keys(e).length;
//   };

//   const handleSave = async () => {
//     if (!validate()) return;
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       const res = await axios.post(
//         `${API_URL}/api/expense/advance`,
//         {
//           user_id: formData.user_id,
//           advance_month: formData.advance_month,
//           amount: parseFloat(formData.amount),
//           location: formData.location,
//           notes: formData.notes,
//         },
//         { headers: { Authorization: authKey } },
//       );
//       if (res.status === 200 || res.status === 201) {
//         showSnackbar(res.data.message || "Advance saved successfully");
//         onSuccess();
//         onClose();
//       }
//     } catch (err) {
//       showSnackbar(
//         err.response?.data?.message || "Error saving advance",
//         "error",
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="exp-overlay">
//       <div className="exp-modal exp-modal--sm">
//         <div className="exp-modal__header">
//           <div className="exp-modal__title-wrap">
//             <div>
//               <h4 className="exp-modal__title">Add Advance</h4>
//               <p className="exp-modal__sub">Fill advance details</p>
//             </div>
//           </div>
//           {/* <button className="exp-modal__close" onClick={onClose}><IoClose size={18} /></button> */}
//         </div>

//         <div className="exp-modal__body">
//           <div className="exp-field-row">
//             <div className="exp-field">
//               <label className="exp-label">
//                 Advance given to <span className="exp-req">*</span>
//               </label>
//               <select
//                 className={`exp-select ${errors.user_id ? "exp-input--err" : ""}`}
//                 value={formData.user_id}
//                 onChange={(e) => handleChange("user_id", e.target.value)}
//                 disabled={usersLoading}
//               >
//                 <option value="">{usersLoading ? "Loading…" : "Select"}</option>
//                 {users.map((u) => (
//                   <option key={u.ID || u.id} value={u.ID || u.id}>
//                     {u.Name || u.name}
//                     {u.Designation ? ` — ${u.Designation}` : ""}
//                   </option>
//                 ))}
//               </select>
//               {errors.user_id && (
//                 <span className="exp-err-msg">{errors.user_id}</span>
//               )}
//             </div>
//             <div className="exp-field">
//               <label className="exp-label">
//                 Advance Month <span className="exp-req">*</span>
//               </label>
//               <input
//                 type="month"
//                 className={`exp-input ${errors.advance_month ? "exp-input--err" : ""}`}
//                 value={formData.advance_month}
//                 onChange={(e) => handleChange("advance_month", e.target.value)}
//               />
//               {errors.advance_month && (
//                 <span className="exp-err-msg">{errors.advance_month}</span>
//               )}
//             </div>
//           </div>

//           <div className="exp-field-row">
//             <div className="exp-field">
//               <label className="exp-label">
//                 Amount (Rs.) <span className="exp-req">*</span>
//               </label>
//               <input
//                 type="number"
//                 placeholder="0.00"
//                 min="0"
//                 step="0.01"
//                 className={`exp-input ${errors.amount ? "exp-input--err" : ""}`}
//                 value={formData.amount}
//                 onChange={(e) => handleChange("amount", e.target.value)}
//               />
//               {errors.amount && (
//                 <span className="exp-err-msg">{errors.amount}</span>
//               )}
//             </div>
//             <div className="exp-field">
//               <label className="exp-label">Location / Site</label>
//               <input
//                 type="text"
//                 placeholder="e.g. Mumbai, Site A"
//                 className="exp-input"
//                 value={formData.location}
//                 onChange={(e) => handleChange("location", e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="exp-field exp-field--full">
//             <label className="exp-label">Notes</label>
//             <textarea
//               className="exp-textarea"
//               rows={3}
//               placeholder="Optional note for this advance"
//               value={formData.notes}
//               onChange={(e) => handleChange("notes", e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="exp-modal__footer">
//           <button className="exp-btn exp-btn--ghost" onClick={onClose}>
//             Cancel
//           </button>
//           <button
//             className="exp-btn exp-btn--primary"
//             onClick={handleSave}
//             disabled={isLoading}
//           >
//             {isLoading && <span className="exp-spinner" />}
//             {isLoading ? "Saving…" : "Save Advance"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────
//    EDIT ADVANCE POPUP
// ───────────────────────────────────────────────────────────────────── */
// const EditAdvancePopup = ({ advance, onClose, onSuccess, showSnackbar }) => {
//   const [isLoading, setIsLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [formData, setFormData] = useState({
//     amount: advance.amount ?? "",
//     location: advance.location ?? "",
//     notes: advance.notes ?? "",
//   });

//   const handleChange = (field, value) => {
//     setFormData((p) => ({ ...p, [field]: value }));
//     if (errors[field]) setErrors((p) => ({ ...p, [field]: "" }));
//   };

//   const validate = () => {
//     const e = {};
//     if (!formData.amount || isNaN(+formData.amount) || +formData.amount < 0)
//       e.amount = "Valid amount is required";
//     setErrors(e);
//     return !Object.keys(e).length;
//   };

//   const handleUpdate = async () => {
//     if (!validate()) return;
//     try {
//       setIsLoading(true);
//       const authKey = localStorage.getItem("authKey");
//       const res = await axios.post(
//         `${API_URL}/api/expense/advance`,
//         {
//           user_id: advance.user_id,
//           advance_month: advance.advance_month,
//           amount: parseFloat(formData.amount),
//           location: formData.location,
//           notes: formData.notes,
//         },
//         { headers: { Authorization: authKey } },
//       );
//       showSnackbar(res.data.message || "Advance updated");
//       onSuccess();
//       onClose();
//     } catch (err) {
//       showSnackbar(
//         err.response?.data?.message || "Error updating advance",
//         "error",
//       );
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="exp-overlay">
//       <div className="exp-modal exp-modal--sm">
//         <div className="exp-modal__header">
//           <div className="exp-modal__title-wrap">
//             <div>
//               <h4 className="exp-modal__title">Edit Advance</h4>
//               <p className="exp-modal__sub">
//                 {advance.employee_name} — {advance.advance_month}
//               </p>
//             </div>
//           </div>
//           {/* <button className="exp-modal__close" onClick={onClose}><IoClose size={18} /></button> */}
//         </div>

//         <div className="exp-modal__body">
//           <div className="exp-info-strip">
//             <div className="exp-info-strip__item">
//               <span className="exp-info-strip__label">Advance given to</span>
//               <span className="exp-info-strip__value">
//                 {advance.employee_name || "—"}
//               </span>
//             </div>
//             <div className="exp-info-strip__item">
//               <span className="exp-info-strip__label">Month</span>
//               <span className="exp-info-strip__value">
//                 {advance.advance_month}
//               </span>
//             </div>
//             {advance.given_by_name && (
//               <div className="exp-info-strip__item">
//                 <span className="exp-info-strip__label">Given By</span>
//                 <span className="exp-info-strip__value">
//                   {advance.given_by_name}
//                 </span>
//               </div>
//             )}
//           </div>

//           <div className="exp-field-row">
//             <div className="exp-field">
//               <label className="exp-label">
//                 Amount (Rs.) <span className="exp-req">*</span>
//               </label>
//               <input
//                 type="number"
//                 min="0"
//                 step="0.01"
//                 className={`exp-input ${errors.amount ? "exp-input--err" : ""}`}
//                 value={formData.amount}
//                 onChange={(e) => handleChange("amount", e.target.value)}
//               />
//               {errors.amount && (
//                 <span className="exp-err-msg">{errors.amount}</span>
//               )}
//             </div>
//             <div className="exp-field">
//               <label className="exp-label">Location / Site</label>
//               <input
//                 type="text"
//                 placeholder="e.g. Mumbai, Site A"
//                 className="exp-input"
//                 value={formData.location}
//                 onChange={(e) => handleChange("location", e.target.value)}
//               />
//             </div>
//           </div>

//           <div className="exp-field exp-field--full">
//             <label className="exp-label">Notes</label>
//             <textarea
//               className="exp-textarea"
//               rows={3}
//               value={formData.notes}
//               onChange={(e) => handleChange("notes", e.target.value)}
//             />
//           </div>
//         </div>

//         <div className="exp-modal__footer">
//           <button className="exp-btn exp-btn--ghost" onClick={onClose}>
//             Cancel
//           </button>
//           <button
//             className="exp-btn exp-btn--primary"
//             onClick={handleUpdate}
//             disabled={isLoading}
//           >
//             {isLoading && <span className="exp-spinner" />}
//             {isLoading ? "Updating…" : "Update Advance"}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// /* ─────────────────────────────────────────────────────────────────────
//    MAIN — Advances List
// ───────────────────────────────────────────────────────────────────── */
// function Expense({ isSidebarExpanded }) {
//   const [advances, setAdvances] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState("");
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarSeverity, setSnackbarSeverity] = useState("success");
//   const [selectedRowIndex, setSelectedRowIndex] = useState(null);
//   const [filterMonth, setFilterMonth] = useState("");
//   const [isAddOpen, setIsAddOpen] = useState(false);
//   const [editAdvance, setEditAdvance] = useState(null);
//   const [viewAdvance, setViewAdvance] = useState(null); // ← new
//   const [page, setPage] = useState(1);
//   const [itemsPerPage, setItemsPerPage] = useState(50);
//   const [totalItems, setTotalItems] = useState(0);
//   const fetchTimeout = useRef(null);
//   const containerRef = useRef(null);
//   const popupRef = useRef(null);
//   const buttonRef = useRef(null);

//   useClickOutside(
//     [containerRef, buttonRef],
//     () => setSelectedRowIndex(null),
//     200,
//   );
//   useClickOutside([popupRef, buttonRef], () => setSelectedRowIndex(null), 300);

//   const showSnackbar = (msg, sev = "success") => {
//     setSnackbarMessage(msg);
//     setSnackbarSeverity(sev);
//     setSnackbarOpen(true);
//   };

//   const fetchData = useCallback(
//     async (cp = page, pp = itemsPerPage, m = filterMonth) => {
//       try {
//         setLoading(true);
//         const authKey = localStorage.getItem("authKey");
//         const params = { page: cp, per_page: pp };
//         if (m) params.advance_month = m;
//         const res = await axios.get(`${API_URL}/api/expense/advances`, {
//           headers: { Authorization: authKey },
//           params,
//         });
//         const data = res.data;
//         setAdvances(Array.isArray(data.advances) ? data.advances : []);
//         setTotalItems(data.total ?? 0);
//       } catch {
//         showSnackbar("Failed to fetch advances", "error");
//       } finally {
//         setLoading(false);
//       }
//     },
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//     [],
//   );

//   useEffect(() => {
//     clearTimeout(fetchTimeout.current);
//     fetchTimeout.current = setTimeout(
//       () => fetchData(page, itemsPerPage, filterMonth),
//       300,
//     );
//     return () => clearTimeout(fetchTimeout.current);
//   }, [page, itemsPerPage, filterMonth, fetchData]);

//   const handlePaginationChange = (p, pp) => {
//     setPage(p);
//     setItemsPerPage(pp);
//   };
//   const handleRefresh = () => {
//     setFilterMonth("");
//     setPage(1);
//     fetchData(1, itemsPerPage, "");
//   };

//   const handleButtonClick = (i, e) => {
//     e.stopPropagation();
//     setSelectedRowIndex(i === selectedRowIndex ? null : i);
//   };

//   const fmt = (val) =>
//     val != null
//       ? `₹${parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
//       : "—";

//   const fmtDate = (val) => {
//     if (!val) return "—";
//     try {
//       return new Date(val).toLocaleDateString("en-IN", {
//         day: "2-digit",
//         month: "short",
//         year: "numeric",
//       });
//     } catch {
//       return val;
//     }
//   };

//   return (
//     <>
//       <div
//         className={`data-list-content-container page-content ${isSidebarExpanded ? "expanded" : "collapsed"}`}
//       >
//         <div
//           className="data-list-content"
//           ref={containerRef}
//           style={{ position: "relative" }}
//         >
//           <div className="data-list-header">
//             <div className="data-list-header-content">
//               <div className="data-list-heading-content-left-side">
//                 Advances
//               </div>
//               <div className="data-list-heading-content-right-side">
//                 <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
//                   <input
//                     type="month"
//                     value={filterMonth}
//                     onChange={(e) => {
//                       setFilterMonth(e.target.value);
//                       setPage(1);
//                     }}
//                     className="filter-dropdown"
//                     style={{ padding: "6px 10px" }}
//                   />
                  
//                   <Tooltip title="Add Advance" arrow>
//                     <button
//                       className="new-button"
//                       onClick={() => setIsAddOpen(true)}
//                     >
//                       <HiOutlinePlus className="new-plus-icon" /> New
//                     </button>
//                   </Tooltip>
//                   <Tooltip title="Refresh" arrow>
//                     <button className="refresh-button" onClick={handleRefresh}>
//                       <TbRefresh className="refresh-icon" />
//                     </button>
//                   </Tooltip>
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div
//             className="data-list-body"
//             onClick={() => setSelectedRowIndex(null)}
//             style={{ height: "86.6vh" }}
//           >
//             <div className="data-list-scroll-body">
//               <div className="data-list-table">
//                 {loading ? (
//                   <div className="loader-container">
//                     <div className="loader" />
//                     <div>Loading…</div>
//                   </div>
//                 ) : advances.length > 0 ? (
//                   <table className="table multilevel-data">
//                     <thead>
//                       <tr>
//                         <th className="center-alignment">SR. NO.</th>
//                         <th>ADVANCE GIVEN TO</th>
//                         <th>MONTH</th>
//                         <th>ADVANCE AMOUNT</th>
//                         <th>LOCATION</th>
//                         <th>NOTES</th>
//                         <th>GIVEN BY</th>
//                         <th>CREATED</th>
//                         <th></th>
//                       </tr>
//                     </thead>
//                     <tbody className="data-list-scroll-bodys">
//                       {advances.map((adv, index) => (
//                         <tr key={adv.id} className="hoverable-row">
//                           <td className="center-alignment">
//                             {(page - 1) * itemsPerPage + index + 1}
//                           </td>
//                           <td style={{ fontWeight: 500 }}>
//                             {adv.employee_name || "—"}
//                           </td>
//                           <td>{adv.advance_month || "—"}</td>
//                           <td>
//                             <span className="exp-amount-cell">
//                               {fmt(adv.amount)}
//                             </span>
//                           </td>
//                           <td>{adv.location || "—"}</td>
//                           <td
//                             style={{
//                               maxWidth: 160,
//                               overflow: "hidden",
//                               textOverflow: "ellipsis",
//                               whiteSpace: "nowrap",
//                             }}
//                             title={adv.notes || ""}
//                           >
//                             {adv.notes || "—"}
//                           </td>
//                           <td>{adv.given_by_name || "—"}</td>
//                           <td style={{ color: "#888", fontSize: 12 }}>
//                             {fmtDate(adv.created_at)}
//                           </td>
//                           <td className="edit-pop">
//                             <button
//                               className="edit-data-button"
//                               onClick={(e) => handleButtonClick(index, e)}
//                             >
//                               <div className="edit-button">
//                                 <MdExpandMore />
//                               </div>
//                             </button>
//                             {selectedRowIndex === index && (
//                               <div className="edit-popup" ref={popupRef}>
//                                 <div className="edit-popup-contant">
//                                   {/* View button */}
//                                   <div className="edit-popup-button">
//                                     <button
//                                       className="edit-button-inquiry"
//                                       onClick={() => {
//                                         setViewAdvance(adv);
//                                         setSelectedRowIndex(null);
//                                       }}
//                                     >
//                                       <IoEyeOutline /> View
//                                     </button>
//                                   </div>
//                                   {/* Edit button */}
//                                   <div className="edit-popup-button">
//                                     <button
//                                       className="edit-button-inquiry"
//                                       onClick={() => {
//                                         setEditAdvance(adv);
//                                         setSelectedRowIndex(null);
//                                       }}
//                                     >
//                                       <MdOutlineModeEditOutline /> Edit
//                                     </button>
//                                   </div>
//                                 </div>
//                               </div>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 ) : (
//                   <div className="no-users-container">
//                     <div className="no-users-message">
//                       No Advance Records Found
//                     </div>
//                   </div>
//                 )}
//               </div>
//               <Pagination
//                 showPerPage={itemsPerPage}
//                 total={totalItems}
//                 onPaginationChange={handlePaginationChange}
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       {isAddOpen && (
//         <AddAdvancePopup
//           onClose={() => setIsAddOpen(false)}
//           onSuccess={() => fetchData(page, itemsPerPage, filterMonth)}
//           showSnackbar={showSnackbar}
//         />
//       )}
//       {editAdvance && (
//         <EditAdvancePopup
//           advance={editAdvance}
//           onClose={() => setEditAdvance(null)}
//           onSuccess={() => fetchData(page, itemsPerPage, filterMonth)}
//           showSnackbar={showSnackbar}
//         />
//       )}
//       {viewAdvance && (
//         <ViewAdvancePopup
//           advance={viewAdvance}
//           onClose={() => setViewAdvance(null)}
//         />
//       )}

//       <Snackbar
//         open={snackbarOpen}
//         autoHideDuration={6000}
//         onClose={(e, r) => {
//           if (r !== "clickaway") setSnackbarOpen(false);
//         }}
//         anchorOrigin={{ vertical: "top", horizontal: "right" }}
//         style={{ marginTop: "35px" }}
//       >
//         <MuiAlert
//           onClose={() => setSnackbarOpen(false)}
//           severity={snackbarSeverity}
//         >
//           {snackbarMessage}
//         </MuiAlert>
//       </Snackbar>
//     </>
//   );
// }

// export default Expense;



// -------------------------------- fix date issue ------------------------- 


import React, { useState, useEffect, useRef, useCallback } from "react";
import { MdOutlineModeEditOutline } from "react-icons/md";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import { HiOutlinePlus } from "react-icons/hi";
import { MdExpandMore } from "react-icons/md";
import { TbRefresh } from "react-icons/tb";
import Tooltip from "@mui/material/Tooltip";
import { IoClose } from "react-icons/io5";
import { IoEyeOutline } from "react-icons/io5";
import axios from "axios";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import API_URL from "../Config.js";
import Pagination from "../Component/Pagination.js";
import useClickOutside from "../useClickOutside";
import "./expense.css";

/* ─────────────────────────────────────────────────────────────────────
   VIEW ADVANCE POPUP
───────────────────────────────────────────────────────────────────── */
const ViewAdvancePopup = ({ advance, onClose }) => {
  const fmtDate = (val) => {
    if (!val) return "—";
    try {
      return new Date(val).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return val;
    }
  };

  const fmt = (val) =>
    val != null
      ? `₹${parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
      : "—";

  const rows = [
    ["Advance given to", advance.employee_name],
    ["Month", advance.advance_month],
    ["Amount", fmt(advance.amount)],
    ["Location", advance.location],
    ["Notes", advance.notes],
    ["Given By", advance.given_by_name],
    ["Created", fmtDate(advance.created_at)],
  ];

  return (
    <div className="exp-overlay">
      <div className="exp-modal exp-modal--sm">
        <div className="exp-modal__header">
          <div className="exp-modal__title-wrap">
            <div>
              <h4 className="exp-modal__title">Advance Details</h4>
              <p className="exp-modal__sub">
                {advance.employee_name} — {advance.advance_month}
              </p>
            </div>
          </div>
          <button className="exp-modal__close" onClick={onClose}>
            <IoClose size={18} />
          </button>
        </div>

        <div className="exp-modal__body">
          <div className="exp-view-table">
            {rows.map(([label, value]) => (
              <div className="exp-view-row" key={label}>
                <span className="exp-view-row__label">{label}</span>
                <span className="exp-view-row__value">{value || "—"}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────────────
   ADD ADVANCE POPUP
───────────────────────────────────────────────────────────────────── */
const AddAdvancePopup = ({ onClose, onSuccess, showSnackbar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [usersLoading, setUsersLoading] = useState(true);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    user_id: "",
    advance_month: new Date().toISOString().slice(0, 7),
    amount: "",
    location: "",
    notes: "",
  });

  useEffect(() => {
    (async () => {
      try {
        const authKey = localStorage.getItem("authKey");
        const res = await axios.get(`${API_URL}/api/get_user`, {
          headers: { Authorization: authKey },
        });
        const d = res.data;
        setUsers(d.users || d.data || d || []);
      } catch {
        setUsers([]);
      } finally {
        setUsersLoading(false);
      }
    })();
  }, []);

  const handleChange = (field, value) => {
    setFormData((p) => ({ ...p, [field]: value }));
    if (errors[field]) setErrors((p) => ({ ...p, [field]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!formData.user_id) e.user_id = "Advance given to is required";
    if (!formData.advance_month) e.advance_month = "Month is required";
    if (!formData.amount || isNaN(+formData.amount) || +formData.amount < 0)
      e.amount = "Valid amount is required";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleSave = async () => {
    if (!validate()) return;
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const res = await axios.post(
        `${API_URL}/api/expense/advance`,
        {
          user_id: formData.user_id,
          advance_month: formData.advance_month,
          amount: parseFloat(formData.amount),
          location: formData.location,
          notes: formData.notes,
        },
        { headers: { Authorization: authKey } },
      );
      if (res.status === 200 || res.status === 201) {
        showSnackbar(res.data.message || "Advance saved successfully");
        onSuccess();
        onClose();
      }
    } catch (err) {
      showSnackbar(
        err.response?.data?.message || "Error saving advance",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="exp-overlay">
      <div className="exp-modal exp-modal--sm">
        <div className="exp-modal__header">
          <div className="exp-modal__title-wrap">
            <div>
              <h4 className="exp-modal__title">Add Advance</h4>
              <p className="exp-modal__sub">Fill advance details</p>
            </div>
          </div>
        </div>

        <div className="exp-modal__body">
          <div className="exp-field-row">
            <div className="exp-field">
              <label className="exp-label">
                Advance given to <span className="exp-req">*</span>
              </label>
              <select
                className={`exp-select ${errors.user_id ? "exp-input--err" : ""}`}
                value={formData.user_id}
                onChange={(e) => handleChange("user_id", e.target.value)}
                disabled={usersLoading}
              >
                <option value="">{usersLoading ? "Loading…" : "Select"}</option>
                {users.map((u) => (
                  <option key={u.ID || u.id} value={u.ID || u.id}>
                    {u.Name || u.name}
                    {u.Designation ? ` — ${u.Designation}` : ""}
                  </option>
                ))}
              </select>
              {errors.user_id && (
                <span className="exp-err-msg">{errors.user_id}</span>
              )}
            </div>
            <div className="exp-field">
              <label className="exp-label">
                Advance Month <span className="exp-req">*</span>
              </label>
              <DatePicker
                selected={
                  formData.advance_month
                    ? new Date(formData.advance_month + "-01")
                    : null
                }
                onChange={(date) =>
                  handleChange(
                    "advance_month",
                    date ? date.toISOString().slice(0, 7) : "",
                  )
                }
                dateFormat="MMM yyyy"
                showMonthYearPicker
                placeholderText="Select month"
                className={`exp-input ${errors.advance_month ? "exp-input--err" : ""}`}
              />
              {errors.advance_month && (
                <span className="exp-err-msg">{errors.advance_month}</span>
              )}
            </div>
          </div>

          <div className="exp-field-row">
            <div className="exp-field">
              <label className="exp-label">
                Amount (Rs.) <span className="exp-req">*</span>
              </label>
              <input
                type="number"
                placeholder="0.00"
                min="0"
                step="0.01"
                className={`exp-input ${errors.amount ? "exp-input--err" : ""}`}
                value={formData.amount}
                onChange={(e) => handleChange("amount", e.target.value)}
              />
              {errors.amount && (
                <span className="exp-err-msg">{errors.amount}</span>
              )}
            </div>
            <div className="exp-field">
              <label className="exp-label">Location / Site</label>
              <input
                type="text"
                placeholder="e.g. Mumbai, Site A"
                className="exp-input"
                value={formData.location}
                onChange={(e) => handleChange("location", e.target.value)}
              />
            </div>
          </div>

          <div className="exp-field exp-field--full">
            <label className="exp-label">Notes</label>
            <textarea
              className="exp-textarea"
              rows={3}
              placeholder="Optional note for this advance"
              value={formData.notes}
              onChange={(e) => handleChange("notes", e.target.value)}
            />
          </div>
        </div>

        <div className="exp-modal__footer">
          <button className="exp-btn exp-btn--ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            className="exp-btn exp-btn--primary"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading && <span className="exp-spinner" />}
            {isLoading ? "Saving…" : "Save Advance"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────────────
   EDIT ADVANCE POPUP
───────────────────────────────────────────────────────────────────── */
const EditAdvancePopup = ({ advance, onClose, onSuccess, showSnackbar }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [formData, setFormData] = useState({
    amount: advance.amount ?? "",
    location: advance.location ?? "",
    notes: advance.notes ?? "",
  });

  const handleChange = (field, value) => {
    setFormData((p) => ({ ...p, [field]: value }));
    if (errors[field]) setErrors((p) => ({ ...p, [field]: "" }));
  };

  const validate = () => {
    const e = {};
    if (!formData.amount || isNaN(+formData.amount) || +formData.amount < 0)
      e.amount = "Valid amount is required";
    setErrors(e);
    return !Object.keys(e).length;
  };

  const handleUpdate = async () => {
    if (!validate()) return;
    try {
      setIsLoading(true);
      const authKey = localStorage.getItem("authKey");
      const res = await axios.post(
        `${API_URL}/api/expense/advance`,
        {
          user_id: advance.user_id,
          advance_month: advance.advance_month,
          amount: parseFloat(formData.amount),
          location: formData.location,
          notes: formData.notes,
        },
        { headers: { Authorization: authKey } },
      );
      showSnackbar(res.data.message || "Advance updated");
      onSuccess();
      onClose();
    } catch (err) {
      showSnackbar(
        err.response?.data?.message || "Error updating advance",
        "error",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="exp-overlay">
      <div className="exp-modal exp-modal--sm">
        <div className="exp-modal__header">
          <div className="exp-modal__title-wrap">
            <div>
              <h4 className="exp-modal__title">Edit Advance</h4>
              <p className="exp-modal__sub">
                {advance.employee_name} — {advance.advance_month}
              </p>
            </div>
          </div>
        </div>

        <div className="exp-modal__body">
          <div className="exp-info-strip">
            <div className="exp-info-strip__item">
              <span className="exp-info-strip__label">Advance given to</span>
              <span className="exp-info-strip__value">
                {advance.employee_name || "—"}
              </span>
            </div>
            <div className="exp-info-strip__item">
              <span className="exp-info-strip__label">Month</span>
              <span className="exp-info-strip__value">
                {advance.advance_month}
              </span>
            </div>
            {advance.given_by_name && (
              <div className="exp-info-strip__item">
                <span className="exp-info-strip__label">Given By</span>
                <span className="exp-info-strip__value">
                  {advance.given_by_name}
                </span>
              </div>
            )}
          </div>

          <div className="exp-field-row">
            <div className="exp-field">
              <label className="exp-label">
                Amount (Rs.) <span className="exp-req">*</span>
              </label>
              <input
                type="number"
                min="0"
                step="0.01"
                className={`exp-input ${errors.amount ? "exp-input--err" : ""}`}
                value={formData.amount}
                onChange={(e) => handleChange("amount", e.target.value)}
              />
              {errors.amount && (
                <span className="exp-err-msg">{errors.amount}</span>
              )}
            </div>
            <div className="exp-field">
              <label className="exp-label">Location / Site</label>
              <input
                type="text"
                placeholder="e.g. Mumbai, Site A"
                className="exp-input"
                value={formData.location}
                onChange={(e) => handleChange("location", e.target.value)}
              />
            </div>
          </div>

          <div className="exp-field exp-field--full">
            <label className="exp-label">Notes</label>
            <textarea
              className="exp-textarea"
              rows={3}
              value={formData.notes}
              onChange={(e) => handleChange("notes", e.target.value)}
            />
          </div>
        </div>

        <div className="exp-modal__footer">
          <button className="exp-btn exp-btn--ghost" onClick={onClose}>
            Cancel
          </button>
          <button
            className="exp-btn exp-btn--primary"
            onClick={handleUpdate}
            disabled={isLoading}
          >
            {isLoading && <span className="exp-spinner" />}
            {isLoading ? "Updating…" : "Update Advance"}
          </button>
        </div>
      </div>
    </div>
  );
};

/* ─────────────────────────────────────────────────────────────────────
   MAIN — Advances List
───────────────────────────────────────────────────────────────────── */
function Expense({ isSidebarExpanded }) {
  const [advances, setAdvances] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [filterMonth, setFilterMonth] = useState("");
  const [isAddOpen, setIsAddOpen] = useState(false);
  const [editAdvance, setEditAdvance] = useState(null);
  const [viewAdvance, setViewAdvance] = useState(null);
  const [page, setPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const [totalItems, setTotalItems] = useState(0);
  const fetchTimeout = useRef(null);
  const containerRef = useRef(null);
  const popupRef = useRef(null);
  const buttonRef = useRef(null);

  useClickOutside(
    [containerRef, buttonRef],
    () => setSelectedRowIndex(null),
    200,
  );
  useClickOutside([popupRef, buttonRef], () => setSelectedRowIndex(null), 300);

  const showSnackbar = (msg, sev = "success") => {
    setSnackbarMessage(msg);
    setSnackbarSeverity(sev);
    setSnackbarOpen(true);
  };

  const fetchData = useCallback(
    async (cp = page, pp = itemsPerPage, m = filterMonth) => {
      try {
        setLoading(true);
        const authKey = localStorage.getItem("authKey");
        const params = { page: cp, per_page: pp };
        if (m) params.advance_month = m;
        const res = await axios.get(`${API_URL}/api/expense/advances`, {
          headers: { Authorization: authKey },
          params,
        });
        const data = res.data;
        setAdvances(Array.isArray(data.advances) ? data.advances : []);
        setTotalItems(data.total ?? 0);
      } catch {
        showSnackbar("Failed to fetch advances", "error");
      } finally {
        setLoading(false);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [],
  );

  useEffect(() => {
    clearTimeout(fetchTimeout.current);
    fetchTimeout.current = setTimeout(
      () => fetchData(page, itemsPerPage, filterMonth),
      300,
    );
    return () => clearTimeout(fetchTimeout.current);
  }, [page, itemsPerPage, filterMonth, fetchData]);

  const handlePaginationChange = (p, pp) => {
    setPage(p);
    setItemsPerPage(pp);
  };

  const handleRefresh = () => {
    setFilterMonth("");
    setPage(1);
    fetchData(1, itemsPerPage, "");
  };

  const handleButtonClick = (i, e) => {
    e.stopPropagation();
    setSelectedRowIndex(i === selectedRowIndex ? null : i);
  };

  const fmt = (val) =>
    val != null
      ? `₹${parseFloat(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}`
      : "—";

  const fmtDate = (val) => {
    if (!val) return "—";
    try {
      return new Date(val).toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch {
      return val;
    }
  };

  return (
    <>
      <div
        className={`data-list-content-container page-content ${isSidebarExpanded ? "expanded" : "collapsed"}`}
      >
        <div
          className="data-list-content"
          ref={containerRef}
          style={{ position: "relative" }}
        >
          <div className="data-list-header">
            <div className="data-list-header-content">
              <PageBackTitle>Advances</PageBackTitle>
              <div className="data-list-heading-content-right-side">
                <div style={{ display: "flex", gap: 8, alignItems: "center", width: "max-content" }}>
                  <DatePicker
                    selected={
                      filterMonth ? new Date(filterMonth) : null
                    }
                    onChange={(date) => {
                      setFilterMonth(
                        date ? date.toISOString().slice(0, 7) : "",
                      );
                      setPage(1);
                    }}
                    dateFormat="MMM yyyy"
                    showMonthYearPicker
                    placeholderText="All months"
                    isClearable
                    className="filter-dropdown"
                  />
                  <Tooltip title="Add Advance" arrow>
                    <button
                      className="new-button"
                      onClick={() => setIsAddOpen(true)}
                      style={{width:"122px"}}
                    >
                      <HiOutlinePlus className="new-plus-icon" /> New
                    </button>
                  </Tooltip>
                  <Tooltip title="Refresh" arrow>
                    <button className="refresh-button" onClick={handleRefresh}>
                      <TbRefresh className="refresh-icon" />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
          </div>

          <div
            className="data-list-body"
            onClick={() => setSelectedRowIndex(null)}
            style={{ height: "86.6vh" }}
          >
            <div className="data-list-scroll-body">
              <div className="data-list-table">
                {loading ? (
                  <div className="loader-container">
                    <div className="loader" />
                    <div>Loading…</div>
                  </div>
                ) : advances.length > 0 ? (
                  <table className="table multilevel-data">
                    <thead>
                      <tr>
                        <th className="center-alignment">SR. NO.</th>
                        <th>ADVANCE GIVEN TO</th>
                        <th>MONTH</th>
                        <th>ADVANCE AMOUNT</th>
                        <th>LOCATION</th>
                        <th>NOTES</th>
                        <th>GIVEN BY</th>
                        <th>CREATED</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody className="data-list-scroll-bodys">
                      {advances.map((adv, index) => (
                        <tr key={adv.id} className="hoverable-row">
                          <td className="center-alignment">
                            {(page - 1) * itemsPerPage + index + 1}
                          </td>
                          <td style={{ fontWeight: 500 }}>
                            {adv.employee_name || "—"}
                          </td>
                          <td>{adv.advance_month || "—"}</td>
                          <td>
                            <span className="exp-amount-cell">
                              {fmt(adv.amount)}
                            </span>
                          </td>
                          <td>{adv.location || "—"}</td>
                          <td
                            style={{
                              maxWidth: 160,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                            }}
                            title={adv.notes || ""}
                          >
                            {adv.notes || "—"}
                          </td>
                          <td>{adv.given_by_name || "—"}</td>
                          <td style={{ color: "#888", fontSize: 12 }}>
                            {fmtDate(adv.created_at)}
                          </td>
                          <td className="edit-pop">
                            <button
                              className="edit-data-button"
                              onClick={(e) => handleButtonClick(index, e)}
                            >
                              <div className="edit-button">
                                <MdExpandMore />
                              </div>
                            </button>
                            {selectedRowIndex === index && (
                              <div className="edit-popup" ref={popupRef}>
                                <div className="edit-popup-contant">
                                  <div className="edit-popup-button">
                                    <button
                                      className="edit-button-inquiry"
                                      onClick={() => {
                                        setViewAdvance(adv);
                                        setSelectedRowIndex(null);
                                      }}
                                    >
                                      <IoEyeOutline /> View
                                    </button>
                                  </div>
                                  <div className="edit-popup-button">
                                    <button
                                      className="edit-button-inquiry"
                                      onClick={() => {
                                        setEditAdvance(adv);
                                        setSelectedRowIndex(null);
                                      }}
                                    >
                                      <MdOutlineModeEditOutline /> Edit
                                    </button>
                                  </div>
                                </div>
                              </div>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                ) : (
                  <div className="no-users-container">
                    <div className="no-users-message">
                      No Advance Records Found
                    </div>
                  </div>
                )}
              </div>
              <Pagination
                showPerPage={itemsPerPage}
                total={totalItems}
                onPaginationChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {isAddOpen && (
        <AddAdvancePopup
          onClose={() => setIsAddOpen(false)}
          onSuccess={() => fetchData(page, itemsPerPage, filterMonth)}
          showSnackbar={showSnackbar}
        />
      )}
      {editAdvance && (
        <EditAdvancePopup
          advance={editAdvance}
          onClose={() => setEditAdvance(null)}
          onSuccess={() => fetchData(page, itemsPerPage, filterMonth)}
          showSnackbar={showSnackbar}
        />
      )}
      {viewAdvance && (
        <ViewAdvancePopup
          advance={viewAdvance}
          onClose={() => setViewAdvance(null)}
        />
      )}

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={6000}
        onClose={(e, r) => {
          if (r !== "clickaway") setSnackbarOpen(false);
        }}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        style={{ marginTop: "35px" }}
      >
        <MuiAlert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>
    </>
  );
}

export default Expense;